// RUTA: /src/context/AdminContext.js
// Estado compartido entre las páginas de /admin/*. Instancia una sola vez
// (vía wrapPageElement en gatsby-browser.js) los hooks de datos "pesados"
// que antes vivían en src/pages/admin.js, para que navegar entre módulos
// de admin no vuelva a hacer fetch de students/briefings desde cero.

import React, { createContext, useContext } from 'react';
import { useAuth } from './AuthContext';
import { useAdminData } from '../hooks/useAdminData';
import { useBriefingManager } from '../hooks/useBriefingManager';
import { useRoleManager } from '../hooks/useRoleManager';

const AdminContext = createContext(null);

export const AdminProvider = ({ children }) => {
  const { currentUser, isAdmin, loading: authLoading } = useAuth();

  const adminData = useAdminData(currentUser, isAdmin, authLoading);
  const briefingManager = useBriefingManager(adminData.selectedStudent, adminData.briefings);
  const roleManager = useRoleManager();

  const value = {
    ...adminData,
    ...briefingManager,
    ...roleManager,
    currentUser,
    isAdmin,
    authLoading,
  };

  return <AdminContext.Provider value={value}>{children}</AdminContext.Provider>;
};

export const useAdminContext = () => {
  const ctx = useContext(AdminContext);
  if (!ctx) {
    throw new Error('useAdminContext debe usarse dentro de <AdminProvider> (ver gatsby-browser.js)');
  }
  return ctx;
};
